/**
 * Регистрация единого service worker (specs/001-pwa-shell/contracts/service-worker.md) — общая
 * для полной и мобильной версии. В сборке это `/sw.js`; dev-сервер (`vite-plugin-pwa`,
 * `devOptions`) отдаёт тот же `src/sw.ts` модулем по адресу `/dev-sw.js?dev-sw`.
 */
export function registerServiceWorker(
    container: ServiceWorkerContainer = navigator.serviceWorker,
    dev: boolean = import.meta.env.DEV
): Promise<ServiceWorkerRegistration> {
    return dev
        ? container.register("/dev-sw.js?dev-sw", { scope: "/", type: "module" })
        : container.register("/sw.js", { scope: "/" });
}
